<template>
  <div>
    <v-row>
      <v-col cols="12">
        <span v-if="kind == 'general'">
          <h3>
            7. Images (photos, étiquettes...), aux formats gif, jpeg ou png
          </h3>
        </span>
        <span v-if="kind == 'references'">
          <h4>
            Images des références (étiquettes...), aux formats gif, jpeg ou png
          </h4>
        </span>
        <span v-if="kind == 'description'">
          <h4>Photos de description, aux formats gif, jpeg ou png</h4>
        </span>
        <span v-if="!readOnly">
          <v-tooltip bottom color="error">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="error"
                v-bind="attrs"
                v-on="on"
                @click.stop="promptConfirmDeletion()"
              >
                <v-icon>mdi-collapse-all</v-icon>
              </v-btn>
            </template>
            <span>Supprimer toutes les images</span>
          </v-tooltip>

          <v-tooltip bottom color="success">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="success"
                v-bind="attrs"
                v-on="on"
                @click.stop="append"
              >
                <v-icon>mdi-plus-box</v-icon>
              </v-btn>
            </template>
            <span>Ajouter une image</span>
          </v-tooltip>
        </span>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-data-table
        class="mt-0"
        :class="{ 'ml-8': kind != 'general' }"
        :items="images"
        :headers="headers"
        :hide-default-header="!images[0]"
        no-data-text="Aucune image associée"
        hide-default-footer
        dense
        disable-pagination
        disable-sort
        disable-filtering
      >
        <template v-slot:[`item.tri`]="{ index }">
          <v-row
            v-if="images.length != 1 && !readOnly"
            style="flex-wrap: nowrap"
            align="center"
            justify="space-around"
          >
            <v-btn
              v-if="index != 0"
              icon
              color="info"
              @click.stop="moveUp(index)"
            >
              <v-icon>mdi-arrow-up-bold-circle</v-icon>
            </v-btn>
            <v-btn
              v-if="index != images.length - 1"
              icon
              color="info"
              @click.stop="moveDown(index)"
            >
              <v-icon>mdi-arrow-down-bold-circle</v-icon>
            </v-btn>
          </v-row>
        </template>
        <template v-slot:[`item.image`]="{ item }">
          <img
            v-if="item.local"
            style="max-width: 250px"
            :src="`data:${item.mimetype};base64,${item.data}`"
            :alt="item.intitule"
          />
          <img
            v-else
            style="max-width: 250px"
            :src="`${cheminImages}${item.fichier}`"
            :alt="item.intitule"
          />
        </template>
        <template v-slot:[`item.commands`]="{ index }">
          <v-row
            style="flex-wrap: nowrap"
            align="center"
            justify="space-around"
          >
            <v-btn
              :disabled="readOnly"
              icon
              color="error"
              @click.stop="promptConfirmDeletion(index)"
            >
              <v-icon>mdi-trash-can</v-icon>
            </v-btn>
            <v-tooltip bottom color="info" v-if="kind != 'description'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="info"
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="moveToDescription(index)"
                >
                  <v-icon>mdi-image-text</v-icon>
                </v-btn>
              </template>
              <span>Déplacer vers description</span>
            </v-tooltip>
            <v-tooltip bottom color="info" v-if="kind != 'references'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="info"
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="moveToReferences(index)"
                >
                  <v-icon>mdi-message-image</v-icon>
                </v-btn>
              </template>
              <span>Déplacer vers références</span>
            </v-tooltip>
            <v-tooltip bottom color="info" v-if="kind != 'general'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="info"
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="moveToImages(index)"
                >
                  <v-icon>mdi-folder-image</v-icon>
                </v-btn>
              </template>
              <span>Déplacer vers images</span>
            </v-tooltip>
          </v-row>
        </template>
        <template v-slot:[`item.fileCtl`]="{ item }">
          <v-row class="d-none">
            <v-file-input :value="item.fileCtl"></v-file-input>
          </v-row>
        </template>
      </v-data-table>

      <v-dialog persistent v-model="showDelConfirm" max-width="410">
        <v-card>
          <v-card-title class="text-h5">
            Confirmation de suppression
          </v-card-title>
          <v-card-text>
            <div v-if="deleteIndex != null">
              Confirmez-vous la suppression de l'image
              {{ imageASupprimer }} ?
            </div>
            <div v-else>
              Confirmez-vous la suppression de toutes les images associées ?
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="doDeletion"> Oui </v-btn>
            <v-btn color="success" text @click="cancelDeletion"> Non </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <produit-image-dialog
        :show="showDialog"
        @ok="confirmImageDialog"
        @cancel="showDialog = false"
      ></produit-image-dialog>
    </v-row>
  </div>
</template>

<script>
import ProduitImageDialog from "@/components/ProduitImageDialog";

export default {
  name: "ProduitImages",
  components: {
    ProduitImageDialog,
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
    kind: {
      type: String,
      default: "general",
    },
  },
  data() {
    return {
      headers: [
        { text: " ", value: "tri" },
        { text: "Image", value: "image" },
        { text: "Fichier", value: "fichier" },
        { text: "Contenu", value: "intitule" },
        { text: " ", value: "commands", sortable: false },
        { text: " ", value: "fileCtl", sortable: false, align: " d-none" },
      ],
      showDelConfirm: false,
      deleteIndex: null,
      showDialog: false,
      //   editIndex: null,
    };
  },
  computed: {
    cheminImages() {
      return process.env.VUE_APP_CHEMIN_IMAGES_PDTS;
    },
    images() {
      switch (this.kind.toLowerCase()) {
        case "general":
          return this.$store.state.demandeEditee.produit.images;

        case "references":
          return this.$store.state.demandeEditee.produit.imagesReferences;

        case "description":
          return this.$store.state.demandeEditee.produit.imagesDescription;
      }
      return null;
    },
    imageASupprimer() {
      if (this.deleteIndex != null) {
        return this.images[this.deleteIndex].fichier;
      }
      return "";
    },
    // imageEditee() {
    //   //console.log(this.editIndex);
    //   if (this.editIndex != null) {
    //     return this.images[this.editIndex];
    //   }
    //   return null;
    // },
  },
  methods: {
    promptConfirmDeletion(index = null) {
      // console.log(index);
      this.deleteIndex = index;
      this.showDelConfirm = true;
    },
    doDeletion() {
      if (this.deleteIndex != null) {
        // this.images.splice(this.deleteIndex, 1);
        this.$store.dispatch("demandeEditee/removeImage", {
          kind: this.kind,
          index: this.deleteIndex,
        });
        this.deleteIndex = null;
      } else {
        // this.images.splice(0, this.images.length);
        this.$store.dispatch("demandeEditee/clearImages", this.kind);
      }
      this.showDelConfirm = false;
    },
    cancelDeletion() {
      this.deleteIndex = null;
      this.showDelConfirm = false;
    },
    confirmImageDialog(img) {
      //   if (this.editIndex) {
      //     this.images.splice(this.editIndex, 1, img);
      //   } else {
      this.$store.dispatch("demandeEditee/addImage", {
        kind: this.kind,
        payload: img,
      });
      //   }
      this.showDialog = false;
    },
    append() {
      //   this.editIndex = null;
      //   this.editedImage = null;
      this.showDialog = true;
    },
    moveUp(index) {
      this.$store.dispatch("demandeEditee/moveImageUp", {
        kind: this.kind,
        index,
      });
    },
    moveDown(index) {
      this.$store.dispatch("demandeEditee/moveImageDown", {
        kind: this.kind,
        index,
      });
    },
    moveToDescription(index) {
      this.$store.dispatch("demandeEditee/moveImageToOtherCollection", {
        kind: this.kind,
        index,
        to: "description",
      });
    },
    moveToReferences(index) {
      this.$store.dispatch("demandeEditee/moveImageToOtherCollection", {
        kind: this.kind,
        index,
        to: "references",
      });
    },
    moveToImages(index) {
      this.$store.dispatch("demandeEditee/moveImageToOtherCollection", {
        kind: this.kind,
        index,
        to: "general",
      });
    },
    // edit(index) {
    //   this.editIndex = index;
    //   this.showDialog = true;
    // },
  },
};
</script>

<style scoped>
h4 {
  margin-left: 2em;
  margin-top: 1.2em;
}

h3,
h4 {
  display: inline-block;
  margin-right: 2em;
}
</style>
